import React from 'react'

export default ({PLACEHOLDER, ...props}) => (
    <svg width="50" height="50" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
        <g clipPath="url(#clip0)">
            <path d="M3.58935 8.03532L10.3348 14.7785C10.6308 15.0737 11.1103 15.0737 11.407 14.7785C11.703 14.4833 11.703 14.0037 11.407 13.7085L5.19665 7.50034L11.4063 1.29219C11.7023 0.996956 11.7023 0.517413 11.4063 0.221428C11.1103 -0.0738094 10.63 -0.0738094 10.334 0.221428L3.5886 6.96456C3.29716 7.25674 3.29716 7.74382 3.58935 8.03532Z" fill="white"/>
        </g>
        <defs>
            <clipPath id="clip0">
                <rect width="15" height="15" fill="white"/>
            </clipPath>
        </defs>
    </svg>
)
